// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2jrv5","header":"header-3R-Za","cards":"cards-1RzmD","dummyCard":"dummyCard-3D6-C"};